/* CUSTOM_FREIGHTHUB_BY_CLAUDE (Freight Hub H2, Ryan 2026-10-15) - Freight Hub -> Offline Freight Finalized Email, the JS half.
   Moved VERBATIM from assets/rep-settings-agent-panels.js when every freight setting left Settings for the
   Freight Hub (decision F3, Freight-Hub/FREIGHT-HUB-PLANNER.md). Markup: snippets/freight-hub-finalized-email.liquid, which
   also loads this file. Same routes, same fields, same save bodies as before the move.
   showMsg / hideMsg are copies of that file's IIFE-local helpers. */
(function() {
  'use strict';
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }
  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
/* CUSTOM_OFFLINENOTIFY_BY_CLAUDE (AIOPS 71e316b23925, 2026-09-08) — Admin: Offline Freight
   Finalized Email. One switch over GET/POST /admin/offline-freight-notify-config, which answer
   the config flat ({enabled}); loaded from the server, never defaulted in the markup. */
var onEnabled = document.getElementById('settings-offnotify-enabled');
var onBtn = document.getElementById('settings-offnotify-btn');
var onMsg = document.getElementById('settings-offnotify-msg');
if (onBtn && onEnabled) {
  (async function loadOn() {
    try {
      var data = await window.RepPortal.API.get('/admin/offline-freight-notify-config');
      onEnabled.checked = !!(data && data.enabled === true);
    } catch (e) {
      showMsg(onMsg, 'Could not load the current setting — reload before saving.', 'error');
    }
  })();
  onBtn.addEventListener('click', async function() {
    hideMsg(onMsg);
    onBtn.disabled = true;
    var orig = onBtn.textContent;
    onBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/offline-freight-notify-config', { enabled: !!onEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      onEnabled.checked = !!(res && res.enabled === true);
      showMsg(onMsg, res && res.enabled
        ? 'Saved — the deal owner is emailed automatically once offline freight is finalized.'
        : 'Saved — no automatic email; the Apply button still sends it.', 'success');
    } catch (e) {
      showMsg(onMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      onBtn.disabled = false;
      onBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_OFFLINENOTIFY_BY_CLAUDE */
/* CUSTOM_FREIGHTADMINNET_BY_CLAUDE (AIOPS 8645a1ddbfca, Ryan 2026-09-15) - the admin safety net's
   own switch, over the same GET/POST /admin/offline-freight-notify-config record.
   ⛔ IT POSTS `adminCopy` ALONE, and the panel above posts `enabled` alone. The route treats an
   omitted field as "keep what is stored", so two buttons on one record cannot clobber each other -
   which is exactly what one shared Save would have done the first time somebody pressed the wrong
   one. Loaded from the server like every other switch here; nothing is defaulted in the markup. */
var ofaEnabled = document.getElementById('settings-offnotify-admin');
var ofaBtn = document.getElementById('settings-offnotify-admin-btn');
var ofaMsg = document.getElementById('settings-offnotify-admin-msg');
if (ofaBtn && ofaEnabled) {
  (async function loadOfa() {
    try {
      var data = await window.RepPortal.API.get('/admin/offline-freight-notify-config');
      ofaEnabled.checked = !!(data && data.adminCopy === true);
    } catch (e) {
      showMsg(ofaMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  ofaBtn.addEventListener('click', async function() {
    hideMsg(ofaMsg);
    ofaBtn.disabled = true;
    var orig = ofaBtn.textContent;
    ofaBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/offline-freight-notify-config', { adminCopy: !!ofaEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      ofaEnabled.checked = !!(res && res.adminCopy === true);
      showMsg(ofaMsg, res && res.adminCopy
        ? 'Saved - ryan@ is emailed when somebody else completes offline freight.'
        : 'Saved - no admin email; only the deal owner is told.', 'success');
    } catch (e) {
      showMsg(ofaMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ofaBtn.disabled = false;
      ofaBtn.textContent = orig;
    }
  });
}
/* CUSTOM_FREIGHTAUTOAPPLY_BY_CLAUDE (Ryan 2026-09-16) - the auto-apply switch, third button on the
   same record, same one-field-per-post rule as the two above.
   ⛔ IT IS THE ONLY SWITCH ON THIS PAGE THAT IS ON WHEN NOTHING IS STORED, and the tick still comes
   from the SERVER rather than being defaulted in the markup - the worker's normalize reads an absent
   `autoApply` as true, so asking it is how the box and the behaviour stay the same thing. Checking
   the box in the HTML would be a second copy of that default, and the first time somebody changed
   the worker's mind the screen would go on saying the old one. */
var ofapEnabled = document.getElementById('settings-offnotify-autoapply');
var ofapBtn = document.getElementById('settings-offnotify-autoapply-btn');
var ofapMsg = document.getElementById('settings-offnotify-autoapply-msg');
if (ofapBtn && ofapEnabled) {
  (async function loadOfap() {
    try {
      var data = await window.RepPortal.API.get('/admin/offline-freight-notify-config');
      ofapEnabled.checked = !!(data && data.autoApply === true);
    } catch (e) {
      showMsg(ofapMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  ofapBtn.addEventListener('click', async function() {
    hideMsg(ofapMsg);
    ofapBtn.disabled = true;
    var orig = ofapBtn.textContent;
    ofapBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/offline-freight-notify-config', { autoApply: !!ofapEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      ofapEnabled.checked = !!(res && res.autoApply === true);
      showMsg(ofapMsg, res && res.autoApply
        ? 'Saved - finished offline freight goes onto the quote by itself. Nobody has to press Apply.'
        : 'Saved - freight stays off the quote until an admin presses Apply to Quote.', 'success');
    } catch (e) {
      showMsg(ofapMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ofapBtn.disabled = false;
      ofapBtn.textContent = orig;
    }
  });
}
/* CUSTOM_FREIGHTMISSWATCH_BY_CLAUDE (Ryan 2026-10-02) - Ryan's Cc on the orders@ freight-request copy.
   Same record, posts `requestCc` alone. The tick comes from the SERVER (an absent value reads ON
   there), for the reason the auto-apply panel above gives. */
var ofrcEnabled = document.getElementById('settings-offnotify-requestcc');
var ofrcBtn = document.getElementById('settings-offnotify-requestcc-btn');
var ofrcMsg = document.getElementById('settings-offnotify-requestcc-msg');
if (ofrcBtn && ofrcEnabled) {
  (async function loadOfrc() {
    try {
      var data = await window.RepPortal.API.get('/admin/offline-freight-notify-config');
      ofrcEnabled.checked = !!(data && data.requestCc !== false);
    } catch (e) {
      showMsg(ofrcMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  ofrcBtn.addEventListener('click', async function() {
    hideMsg(ofrcMsg);
    ofrcBtn.disabled = true;
    var orig = ofrcBtn.textContent;
    ofrcBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/offline-freight-notify-config', { requestCc: !!ofrcEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      ofrcEnabled.checked = !!(res && res.requestCc !== false);
      showMsg(ofrcMsg, res && res.requestCc !== false
        ? 'Saved - you are copied on every freight request a rep makes.'
        : 'Saved - freight requests go to orders@ only. You are no longer copied.', 'success');
    } catch (e) {
      showMsg(ofrcMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ofrcBtn.disabled = false;
      ofrcBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_FREIGHTADMINNET_BY_CLAUDE */
/* CUSTOM_FREIGHTREQSTALE_BY_CLAUDE (ONYX 918a2409ed5e, Ryan 2026-10-09) - the untouched-freight-request email,
   fifth switch on the same record, posts `staleEmail` alone. The tick comes from the SERVER (absent reads OFF). */
var ofseEnabled = document.getElementById('settings-offnotify-staleemail');
var ofseBtn = document.getElementById('settings-offnotify-staleemail-btn');
var ofseMsg = document.getElementById('settings-offnotify-staleemail-msg');
if (ofseBtn && ofseEnabled) {
  (async function loadOfse() {
    try {
      var data = await window.RepPortal.API.get('/admin/offline-freight-notify-config');
      ofseEnabled.checked = !!(data && data.staleEmail === true);
    } catch (e) {
      showMsg(ofseMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  ofseBtn.addEventListener('click', async function() {
    hideMsg(ofseMsg);
    ofseBtn.disabled = true;
    var orig = ofseBtn.textContent;
    ofseBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/offline-freight-notify-config', { staleEmail: !!ofseEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      ofseEnabled.checked = !!(res && res.staleEmail === true);
      showMsg(ofseMsg, res && res.staleEmail === true
        ? 'Saved - you get one email when a freight request is still untouched after the agent was woken twice.'
        : 'Saved - no email; only the agent is reminded about untouched freight requests.', 'success');
    } catch (e) {
      showMsg(ofseMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ofseBtn.disabled = false;
      ofseBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_FREIGHTREQSTALE_BY_CLAUDE */
/* CUSTOM_FAMILYREQUEST_BY_CLAUDE (ONYX a9af5972f436 + 6c08dd4d325f, Ryan 2026-10-10) - the two family freight dials, their own Save.
   The values come from the SERVER (absent reads as the defaults, 20% and 10 minutes). */
var famRescale = document.getElementById('settings-family-rescale');
var famSettle = document.getElementById('settings-family-settle');
var famBtn = document.getElementById('settings-family-btn');
var famMsg = document.getElementById('settings-family-msg');
if (famBtn && famRescale && famSettle) {
  (async function loadFam() {
    try {
      var data = await window.RepPortal.API.get('/admin/family-freight-config');
      famRescale.value = (data && data.rescaleMaxPct) || 20;
      famSettle.value = (data && data.addsSettleMinutes) || 10;
    } catch (e) {
      showMsg(famMsg, 'Could not load the current setting - reload before saving.', 'error');
    }
  })();
  famBtn.addEventListener('click', async function() {
    hideMsg(famMsg);
    famBtn.disabled = true;
    var orig = famBtn.textContent;
    famBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/family-freight-config', { rescaleMaxPct: Number(famRescale.value), addsSettleMinutes: Number(famSettle.value) });
      if (res && res.error) throw new Error(res.error);
      famRescale.value = res.rescaleMaxPct;
      famSettle.value = res.addsSettleMinutes;
      showMsg(famMsg, 'Saved - a version is scaled when its amount moved ' + res.rescaleMaxPct + '% or less, and added versions are sent to the agent ' + res.addsSettleMinutes + ' minutes after the last one.', 'success');
    } catch (e) {
      showMsg(famMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      famBtn.disabled = false;
      famBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_FAMILYREQUEST_BY_CLAUDE */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_FREIGHTHUB_BY_CLAUDE */
